"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactDnd = require("react-dnd");
var _FormBlock = _interopRequireDefault(require("../FormBlock"));
var _checkForErrors = _interopRequireDefault(require("../../helpers/checkForErrors.js"));
var _getWysiwygText = _interopRequireDefault(require("../../helpers/getWysiwygText.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var source = {
  beginDrag: function beginDrag(props, monitor, component) {
    return {
      id: props.element.id.value
    };
  },
  canDrag: function canDrag(props, monitor) {
    return props.canDrag;
  }
};
var target = {
  hover: function hover(props, monitor, component) {
    // Determine rectangle on screen
    var hoverBoundingRect = _reactDom["default"].findDOMNode(component).getBoundingClientRect();

    // Get horizontal middle
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    var clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
    if (hoverClientY < hoverMiddleY) {
      props.movePlaceholderBefore(props.element.id.value);
    } else {
      props.movePlaceholderAfter(props.element.id.value, monitor.getItem().id);
    }
  }
};
function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}
function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}
var ElementTargetItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ElementTargetItem, _React$Component);
  function ElementTargetItem() {
    var _this;
    _classCallCheck(this, ElementTargetItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ElementTargetItem, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_renderElementField", function () {
      var _this$props = _this.props,
        element = _this$props.element,
        elementTypes = _this$props.elementTypes,
        elementField = _this$props.elementField;
      var Component = elementTypes[element.type.value].component;
      return /*#__PURE__*/_react["default"].createElement(Component, {
        fields: elementField,
        extraProps: _this.props.extraProps
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_deleteElement", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      _this.props.deleteElement(_this.props.index);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderElementActions", function () {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: _this._deleteElement,
        title: "Remove element"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "glyphicon glyphicon-remove"
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderElement", function () {
      return _this.props.renderElement(_this.props.element, _this._renderElementField());
    });
    _defineProperty(_assertThisInitialized(_this), "_onKeyPressed", function (event) {
      if (event.key === 'Tab') {
        event.preventDefault();
        _this.props.goToNextElement(_this.props.element);
      }
    });
    return _this;
  }
  _createClass(ElementTargetItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        connectDropTarget = _this$props2.connectDropTarget,
        connectDragSource = _this$props2.connectDragSource,
        element = _this$props2.element,
        elementField = _this$props2.elementField,
        elementTypes = _this$props2.elementTypes,
        isDragging = _this$props2.isDragging,
        blockType = _this$props2.blockType;

      // Don't show element if we're dragging it
      if (isDragging) {
        return null;
      }
      return connectDropTarget( /*#__PURE__*/_react["default"].createElement("div", {
        onKeyDown: this._onKeyPressed
      }, /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
        key: element.isExpanded.value.toString(),
        title: (0, _getWysiwygText["default"])(element.label.value),
        type: blockType,
        icon: elementTypes[element.type.value].icon,
        rightBlock: this._renderElementActions(),
        show: element.isExpanded.value,
        handleClick: function handleClick(show, event) {
          if (event.shiftKey) {
            _this2.props.toggleAllElements(show);
          } else {
            element.isExpanded.onChange(show);
          }
        },
        connectDragSource: connectDragSource,
        isError: (0, _checkForErrors["default"])([element, elementField])
      }, this._renderElement())));
    }
  }]);
  return ElementTargetItem;
}(_react["default"].Component);
_defineProperty(ElementTargetItem, "propTypes", {
  connectDropTarget: _propTypes["default"].func.isRequired,
  connectDragSource: _propTypes["default"].func.isRequired,
  isDragging: _propTypes["default"].bool.isRequired,
  constant: _propTypes["default"].string,
  index: _propTypes["default"].number,
  element: _propTypes["default"].object,
  elementTypes: _propTypes["default"].object,
  elementField: _propTypes["default"].object,
  deleteElement: _propTypes["default"].func,
  renderElement: _propTypes["default"].func,
  blockType: _propTypes["default"].string,
  canDrag: _propTypes["default"].bool,
  movePlaceholderBefore: _propTypes["default"].func,
  movePlaceholderAfter: _propTypes["default"].func,
  toggleAllElements: _propTypes["default"].func,
  goToNextElement: _propTypes["default"].func,
  extraProps: _propTypes["default"].object
});
var _default = exports["default"] = (0, _reactDnd.DropTarget)(function (props) {
  return props.constant;
}, target, collectTarget)((0, _reactDnd.DragSource)(function (props) {
  return props.constant;
}, source, collectSource)(ElementTargetItem));